import { render, staticRenderFns } from "./SocialmediaComponent.vue?vue&type=template&id=3e3ba48f&scoped=true"
import script from "./SocialmediaComponent.vue?vue&type=script&lang=js"
export * from "./SocialmediaComponent.vue?vue&type=script&lang=js"
import style0 from "./SocialmediaComponent.vue?vue&type=style&index=0&id=3e3ba48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3ba48f",
  null
  
)

export default component.exports